export const DATE_PICKER_FORMAT = [
  'DD.MM.YYYY',
  'YYYY-MM-DD',
  'DDMMYYYY',
  'DD,MM,YYYY',
];

export const DATE_PICKER_WITH_TIME_FORMAT = 'DD.MM.YYYY HH:mm';

export const ISO_FORMAT_INDEX = 1;
